<template>
  <section class="section-1 wrapper">
    <div class="pic mb" />

    <div class="hd">
      <h2 class="title">
        TPS交易系统
      </h2>
    </div>

    <div class="content">
      <h3>交易小白也可轻松复制</h3>
      <p>TTPS，师承H.M.Gartley、Larry Pesavento等早期图形分析大师，以AL Brooks等欧美职业交易员的裸K价格行为交易体系为基础，并根据8年实战和复盘做深度优化及去伪存真，同时系统通过不同价格之间的和谐比率关系，叠加局部价格形态信号，辅以经平滑优化后的凯利公式下的第三方风控体系、和改良自美国期货大赛冠军Bosch的资金管理体系，最大化保持进出场信号的客观性，止盈止损的明确性，仓位管理的科学性。</p>
    </div>

    <btn-contact name="B页-TPPS交易系统-预约咨询" />
  </section>
</template>

<script>
import BtnContact from './BtnContact.vue';

export default {
  name: 'Section1',
  components: {
    BtnContact,
  },
};
</script>

<style scoped lang="scss">
$contentWidth: 1440px;

.section-1 {
  padding-top: percentage(124px / $deviceWidth);
  padding-bottom: percentage(86px / $deviceWidth);
  text-align: center;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: percentage(383px / $deviceWidth);
    padding-top: percentage(428px / $deviceWidth);
    margin-bottom: percentage(94px / $deviceWidth);
    background: url("~assets/T.png") center/contain no-repeat;
    @include hdpi() {
      background-image: url("~assets/T@2x.png");
    }
  }

  &.active {
    .content {
      animation: bounceInLeft .8s both;

      &::after {
        animation: TTPS_bounceInRight .8s .4s both;
      }
    }
  }

  .title {
    width: percentage(559px / $deviceWidth);
    padding-top: percentage(132px / $deviceWidth);
  }

  .content {
    opacity: 0;
    position: relative;
    width: percentage(480px / $deviceWidth);
    margin-left: percentage(240px / $deviceWidth);
    margin-bottom: percentage(120px / $deviceWidth);
    text-align: left;

    h3 {
      position: relative;
      margin: percentage(132px / 480px) auto percentage(74px / 480px);
      font-size: 30px;
      line-height: 32px;
      color: #3A4047;

      &::after {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
        width: percentage(32px / 480px);
        padding-top: percentage(32px / 480px);
        background: url("~assets/arrow.png") center/contain no-repeat;
      }
    }

    p {
      position: relative;
      padding-top: percentage(50px / 480px);
      font-size: 18px;
      color: #3A4047;
      line-height: 32px;
      opacity: .7;

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #3A4047;
        opacity: .1;
      }
    }

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: percentage((480px + 116px) / 480px);
      transform: translate(0, -50%);
      width: percentage(894px / 480px);
      padding-top: percentage(460px / 480px);
      background: url("~assets/ttps.png") center/contain no-repeat;
      @include hdpi() {
        background-image: url("~assets/ttps@2x.png");
      }
    }
  }

  @include mediaWidth(1440px) {
    .content {
      h3 {
        margin: 18% auto 10%;
        font-size: 24px;
      }
      p {
        font-size: 16px;
        line-height: 28px;
      }
    }
  }

  @include mediaWidth(1024px) {
    .content {
      margin-left: percentage(32px / 1024px);
      width: 40%;

      &::after {
        width: 110%;
      }
    }
  }

  @include mediaWidth(#{$mbWidth}) {
    padding-top: 0;

    .pic {
      width: percentage(630px / $mbWidth);
      padding-top: percentage(325px / $mbWidth);
      margin: percentage(50px / $mbWidth) auto percentage(84px / $mbWidth);
      background: url("~assets/ttps.png") center/contain no-repeat;
      @include hdpi() {
        background-image: url("~assets/ttps@2x.png");
      }
    }
    .title {
      width: percentage(346px / $mbWidth);
      padding-top: percentage(81px / $mbWidth);
    }
    .content {
      width: percentage(680px / $mbWidth);
      margin-left: 0;
      margin: 0 auto percentage(50px / $mbWidth);

      &::after {
        content: none;
      }

      h3 {
        font-size: 20px;
        margin: percentage(56px / 680px) 0 percentage(32px / 680px);

        &::after {
          width: 25px;
          height: 25px;
          padding-top: 0;
          transform: translate(0, -50%) rotate(90deg);
        }
      }

      p {
        padding-top: percentage(33px / 680px);
        font-size: 16px;
        line-height: 28px;
      }
    }
  }

  @include mediaWidth(528px) {
    .content {
      h3 {
        font-size: 16px;
        &::after {
          width: 22px;
          height: 22px;
        }
      }
      p {
        font-size: 12px;
        line-height: 22px;
      }
    }
  }
}
</style>
